<template>
    <!-- Kombi: Zahn zuerst (ZVS, ZVP, ZX2, S1, S2) -->
    <template v-if="isKombi">
        <Kombi1ZvsButton 
            :itemId="item.id" 
            :beitragStr="item.tarif1beitragStr" 
            :selected="item.tarif1 === 1"
            :verfuegbar="isTarifVerfuegbar('ZVS')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(1)"
        />
        <Kombi2ZvpButton 
            :itemId="item.id" 
            :beitragStr="item.tarif2beitragStr" 
            :selected="item.tarif2 === 1"
            :verfuegbar="isTarifVerfuegbar('ZVP')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(2)"
        />
        <Kombi3Zx2Button 
            :itemId="item.id" 
            :beitragStr="item.tarif3beitragStr" 
            :selected="item.tarif3 === 1"
            :verfuegbar="isTarifVerfuegbar('ZX2')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(3)"
        />
        <Kombi4S1Button 
            :itemId="item.id" 
            :beitragStr="item.tarif4beitragStr" 
            :selected="item.tarif4 === 1"
            :verfuegbar="isTarifVerfuegbar('S1')"
            @select="handleTarifSelect(4)"
        />
        <Kombi5S2Button 
            :itemId="item.id" 
            :beitragStr="item.tarif5beitragStr" 
            :selected="item.tarif5 === 1"
            :verfuegbar="isTarifVerfuegbar('S2')"
            @select="handleTarifSelect(5)"
        />
    </template>

    <!-- Kombistat: Stationär zuerst (S1, S2, ZVS, ZVP, ZX2) -->
    <template v-else>
        <Kombi4S1Button 
            :itemId="item.id" 
            :beitragStr="item.tarif4beitragStr" 
            :selected="item.tarif4 === 1"
            :verfuegbar="isTarifVerfuegbar('S1')"
            @select="handleTarifSelect(4)"
        />
        <Kombi5S2Button 
            :itemId="item.id" 
            :beitragStr="item.tarif5beitragStr" 
            :selected="item.tarif5 === 1"
            :verfuegbar="isTarifVerfuegbar('S2')"
            @select="handleTarifSelect(5)"
        />
        <Kombi1ZvsButton 
            :itemId="item.id" 
            :beitragStr="item.tarif1beitragStr" 
            :selected="item.tarif1 === 1"
            :verfuegbar="isTarifVerfuegbar('ZVS')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(1)"
        />
        <Kombi2ZvpButton 
            :itemId="item.id" 
            :beitragStr="item.tarif2beitragStr" 
            :selected="item.tarif2 === 1"
            :verfuegbar="isTarifVerfuegbar('ZVP')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(2)"
        />
        <Kombi3Zx2Button 
            :itemId="item.id" 
            :beitragStr="item.tarif3beitragStr" 
            :selected="item.tarif3 === 1"
            :verfuegbar="isTarifVerfuegbar('ZX2')"
            :spalten="zahnSpalten"
            @select="handleTarifSelect(3)"
        />
    </template>
</template>

<script setup>
import { computed } from 'vue';
import { useTarifinfosStore } from '../../stores/tarifinfos';
import { useMainStore } from '../../stores/useMainStore';
import { useRechnerStore } from '../../stores/rechner';

import Kombi1ZvsButton from './kombi_1_zvs_button.vue';
import Kombi2ZvpButton from './kombi_2_zvp_button.vue';
import Kombi3Zx2Button from './kombi_3_zx2_button.vue';
import Kombi4S1Button from './kombi_4_s1_button.vue';
import Kombi5S2Button from './kombi_5_s2_button.vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['tarif-changed']);

const tarifinfosStore = useTarifinfosStore();
const mainStore = useMainStore();
const rechnerStore = useRechnerStore();

// Rechner-Typ: kombi oder kombistat
const isKombi = computed(() => mainStore.dataAttributes.rechner === 'kombi');

// Spaltenanzahl für Zahn-Buttons: 4 wenn ZVS verfügbar, sonst 6
const zahnSpalten = computed(() => isTarifVerfuegbar('ZVS') ? 4 : 6);

// Prüft ob ein Tarif für die aktuelle Variante verfügbar ist
const isTarifVerfuegbar = (tarifCode) => {
    const variante = mainStore.currentVariante;
    if (!variante || !tarifinfosStore.isLoaded) return false;
    return tarifinfosStore.isTarifVerfuegbar(variante, tarifCode);
};

// Setzt den Tarif für das aktuelle Item und emittiert Event für Revalidierung
const handleTarifSelect = (tarifNummer) => {
    rechnerStore.setTarif(props.item.id, tarifNummer);
    emit('tarif-changed', tarifNummer);
};
</script>